import { DeepLinkingShare } from './createShareURL'

export const deepLinkingShare = async (
  deps,
  app,
  actionId,
  datasourceId,
  baseURL
) => {
  if (!window.navigator.share) {
    // eslint-disable-next-line no-alert
    window.alert('Sharing is not supported by this browser.')
    return
  }

  const url = await DeepLinkingShare.buildUrl(
    app,
    actionId,
    deps,
    true,
    datasourceId,
    baseURL
  )

  if (!url) {
    // eslint-disable-next-line no-alert
    window.alert('No URL found for sharing.')
    return
  }

  const shareOpts = {
    title: '',
    text: url,
  }

  await navigator
    .share(shareOpts)
    .then(() => {
      // eslint-disable-next-line no-alert
      window.alert('Shared successfully!')
    })
    .catch(err => {
      console.log(`Couldn't share because of`, err.message)
      // eslint-disable-next-line no-alert
      window.alert(`Error sharing: ${err.message}`)
    })
}
